<template>
<div>
  <v-card
     class="autoscroll mx-auto"
  >
    <v-toolbar>
      <img class="logo" src="../../assets/logo.png" />
      <div class="fullwidth">
        <div class="nametag">
          <span v-if="firstName" class="float-right ml-10">
            {{ firstName }} {{ lastName }}
          </span>
          <span v-if="firstName" class="float-right ml-10">
            {{ email }}
          </span>
        </div>
        <div>
            <v-avatar class="float-right" color="#65893b">
                <v-icon dark> mdi-account-circle </v-icon>
              </v-avatar>
            <v-dialog v-model="dialog" width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="float-right mt-1" icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-help</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                  Help Center
                </v-card-title>
                <v-card-text> </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="dialog = false"> OK </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
      </div>
    </v-toolbar>

    <v-container>
      <v-form v-model="valid" lazy-validation ref="form">
      <v-stepper v-model="step">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1"> App Info</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 2" step="2"> COBOL </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 3" step="3">
            Batch Jobs
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 4" step="4"> CICS </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 5" step="5"> Additional Users </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="6"> Summary </v-stepper-step>

        </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content
              step="1"
            >
              <v-card class="mb-1" color="grey darken-1">
                <v-card-title class="text--primary">
                  Application Information
                </v-card-title>
                <v-card-text>
                  <v-text-field
                    label="Application Name"
                    v-model="ApplicationName"
                    hide-details="auto"
                    :rules="requiredRules"
                  ></v-text-field>
                  <v-select
                    v-model="Language"
                    :items="items"
                    label="Language"
                  ></v-select>
                  <v-textarea
                    v-model="Memo"
                    no-resize
                    clear-icon="mdi-close-circle"
                    label="Memo"
                  ></v-textarea>
                </v-card-text>
              </v-card>
              <v-btn class="mx-2" color="primary" @click="next"> 
                Continue <v-icon right> mdi-chevron-double-right </v-icon> 
              </v-btn>
              <ExitWizardButton @click="$emit('exit')" class="floatright">
              </ExitWizardButton>
            </v-stepper-content>
            <v-stepper-content
              step="2"
            >
              <v-card class="mb-1" color="grey darken-1">
                <v-card-title class="text--primary">
                  Upload COBOL ZIP Directories
                </v-card-title>
                <CloseableChipFileInput
                  fileinputlabel="Upload Program Files ZIP Directories"
                  v-model="programFiles"
                  :rules="requiredRules"
                ></CloseableChipFileInput>
                <CloseableChipFileInput
                  fileinputlabel="Upload Copybook Files ZIP Directories"
                  v-model="copybookFiles"
                  :rules="requiredRules"
                  @input="setListBoxValues" 
                ></CloseableChipFileInput>
                <CloseableChipFileInput
                  fileinputlabel="Upload DDL Schema ZIP Directories"
                  v-model="schemaFiles"
                  @input="setListBoxValues"
                ></CloseableChipFileInput>
                <div class="mx-12">
                  <v-radio-group v-model="diffSeqSQL">
                    <div>Do you have a different sequence for SQL?</div>
                    <v-radio label="Yes" value="Yes"> </v-radio>
                    <v-radio label="No" value="No"> </v-radio>
                  </v-radio-group>
                </div>
                  
                <v-container fluid>
                  <v-row>
                    <v-col cols="6" sm="4">
                      <v-list tile min-height="350">
                          <v-subheader>Copybook Program Sequence</v-subheader>
                          <v-list-item-group
                              class="autoscroll listbox text-left"
                              v-model="selectedProgramSeqItem"
                              color="primary"
                          >
                              <v-list-item
                                  ref="selectedProgramItem"
                                  v-for="(item, i) in copybookProgramSeq" 
                                  :key="i"
                              >
                                  <v-list-item-content>
                                      <v-list-item-title v-text="item.name"></v-list-item-title>
                                  </v-list-item-content>
                              </v-list-item>
                          </v-list-item-group>
                      </v-list>
                  </v-col>
                  <v-col cols="1" sm="1">
                      <div class="text-center">
                      <div class="my-4">
                          <v-btn
                          min-width="118"
                          dark
                          @click="
                              (copybookProgramSeq = moveItemUp(
                                copybookProgramSeq,
                                selectedProgramSeqItem
                              )),
                              (selectedProgramSeqItem = moveSelectionUp(
                                  selectedProgramSeqItem, 
                                  $refs.selectedProgramItem
                              ))
                          "
                          >
                          Move Up
                          </v-btn>
                      </div>
                      <div class="my-4">
                          <v-btn
                          dark
                          @click="
                              (copybookProgramSeq = moveItemDown(
                              copybookProgramSeq,
                              selectedProgramSeqItem
                              )),
                              (selectedProgramSeqItem = moveSelectionDown(
                                  copybookProgramSeq,
                                  selectedProgramSeqItem,
                                  $refs.selectedProgramItem
                              ))
                          "
                          >
                          Move Down
                          </v-btn>
                      </div>
                      </div>
                  </v-col>
                  
                  <v-col v-if="diffSeqSQL == 'Yes'" offset-md="1" cols="6" sm="4">
                      <v-list 
                          v-if="diffSeqSQL == 'Yes'" 
                          min-height="200"
                      >
                          <v-subheader>Copybook SQL Sequence</v-subheader>
                          <v-list-item-group
                              class="autoscroll listbox text-left"
                              v-model="selectedSQLSeqItem"
                              color="primary"
                          >
                          <v-list-item 
                            ref="selectedSQLItem"
                            v-for="(item, i) in copybookSQLSeq" :key="i"
                          >
                          <v-list-item-content>
                              <v-list-item-title v-text="item.name"></v-list-item-title>
                          </v-list-item-content>
                          </v-list-item>
                      </v-list-item-group>
                      </v-list>
                  </v-col>
                  <v-col v-if="diffSeqSQL == 'Yes'" cols="1" sm="1">
                      <div class="text-center">
                      <div class="my-4">
                          <v-btn
                          min-width="118"
                          dark
                          @click="
                              (copybookSQLSeq = moveItemUp(
                                copybookSQLSeq,
                                selectedSQLSeqItem
                              )),
                              (selectedSQLSeqItem = moveSelectionUp(
                                selectedSQLSeqItem,
                                $refs.selectedSQLItem
                              ))
                          "
                          >
                          Move Up
                          </v-btn>
                      </div>
                      <div class="my-4">
                          <v-btn
                          dark
                          @click="
                              (copybookSQLSeq = moveItemDown(
                                copybookSQLSeq,
                                selectedSQLSeqItem
                              )),
                              (selectedSQLSeqItem = moveSelectionDown(
                                  copybookSQLSeq,
                                  selectedSQLSeqItem,
                                  $refs.selectedSQLItem
                              ))
                          "
                          >
                          Move Down
                          </v-btn>
                      </div>
                      </div>
                  </v-col>
                  </v-row>
                </v-container>
              </v-card>
              <v-btn text @click="previous"> 
                <v-icon left> mdi-chevron-double-left </v-icon>Back 
              </v-btn>

              <v-btn class="mx-2" color="primary" @click="next"> 
                Continue <v-icon right> mdi-chevron-double-right </v-icon>
              </v-btn>

              <ExitWizardButton @click="$emit('exit')" class="floatright">
              </ExitWizardButton>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card class="mb-12" color="grey darken-1" height="350px">
                <v-card-title class="text--primary">
                  Upload JCL
                </v-card-title>
                <CloseableChipFileInput
                  fileinputlabel="Upload JCL"
                  v-model="jclFiles"
                ></CloseableChipFileInput>
                <CloseableChipFileInput
                  fileinputlabel="Upload JCL Proc"
                  v-model="jclProcFiles"
                ></CloseableChipFileInput>
                <CloseableChipFileInput
                  fileinputlabel="Upload JCL Parm Card"
                  v-model="jclParmCardFiles"
                ></CloseableChipFileInput>
              </v-card>
              <v-btn text @click="previous"> 
                <v-icon left> mdi-chevron-double-left </v-icon>Back 
              </v-btn>
              <v-btn color="primary" @click="next"> 
                Continue <v-icon right> mdi-chevron-double-right </v-icon>
              </v-btn>
              <ExitWizardButton @click="$emit('exit')" class="floatright">
              </ExitWizardButton>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-card class="mb-12" color="grey darken-1" height="200px">
                <v-card-title class="text--primary">
                  Upload CICS
                </v-card-title>
                <CloseableChipFileInput
                  fileinputlabel="Upload CICS"
                  v-model="cicsFiles"
                ></CloseableChipFileInput>
                <CloseableChipFileInput
                  fileinputlabel="Upload Mapset(BMS)"
                  v-model="bmsFiles"
                ></CloseableChipFileInput>
              </v-card>
              <v-btn text @click="previous"> 
                <v-icon left> mdi-chevron-double-left </v-icon> Back 
              </v-btn>
              <v-btn color="primary" @click="next"> 
                Continue <v-icon right> mdi-chevron-double-right </v-icon>
              </v-btn>
              <ExitWizardButton @click="$emit('exit')" class="floatright">
              </ExitWizardButton>
            </v-stepper-content>

            <v-stepper-content step="5">
              <v-container fluid>
                <v-row>
                  <v-col>
                    <v-card class="mb-12" color="grey darken-1">
                      <v-card-title class="text--primary">
                        Add Additional Users
                      </v-card-title>
                  
                      <v-form
                        ref="form"
                        v-model="form1"
                        lazy validation
                      >
                        <v-container>
                          <v-row v-for="(user,index) in users" v-bind:key="index">
                            <v-col
                              cols="12"
                              md="3"
                              sm="6"
                            >
                              <v-text-field
                                v-model="users[index].firstName"
                                label="First name"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="3"
                              sm="6"
                            >
                              <v-text-field
                                v-model="users[index].lastName"
                                label="Last name"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="4"
                              sm="6"
                            >
                              <v-text-field
                                v-model="users[index].email"
                                :rules='emailvalidation(users[index].firstName, users[index].lastName)'
                                label="E-mail"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="1"
                              md="1"
                              sm="6"
                            >
                              <v-btn
                                color="primary"
                                @click="addMoreUser"
                              >
                                <v-icon dark>
                                  mdi-plus
                                </v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-btn text @click="previous"> 
                <v-icon left> mdi-chevron-double-left </v-icon> Back
              </v-btn>

              <v-btn color="primary" @click="next"> 
                Continue <v-icon right> mdi-chevron-double-right </v-icon>
              </v-btn>

              <ExitWizardButton @click="$emit('exit')" class="floatright">
              </ExitWizardButton>
            </v-stepper-content>

            <v-stepper-content step="6">
            <v-card elevation="2" class="mb-1" color="grey darken-1">
              <v-card-title class="text--primary">
                  Summary
                </v-card-title>
                <v-card-text>
                  <fieldset class="rounded">
                    <legend class="rounded">
                      App Info
                    </legend>
                      <EditButton
                        @step="step = 1"
                        class="editbtn"
                      ></EditButton>
                      <SummaryGrid
                        labelText="Application name:"
                        :textfield="ApplicationName"
                        class="mx-2"
                      >
                      </SummaryGrid>
                      <SummaryGrid
                        labelText="Language:"
                        :textfield="Language"
                        class="mx-2"
                      >
                      </SummaryGrid>
                      <SummaryGrid
                        labelText="Memo:"
                        :textfield="Memo"
                        class="mx-2"
                      >
                      </SummaryGrid>
                  </fieldset>
                  <fieldset class="mt-5 rounded">
                    <legend class="rounded">
                      COBOL
                    </legend>
                    <EditButton
                        @step="step = 2"
                        class="editbtn"
                    ></EditButton>
                    <SummaryGrid
                      labelText="Cobol programs:"
                      :list="programFiles"
                      class="mx-2"
                    >
                    </SummaryGrid>
                    <SummaryGrid
                      labelText="Cobol copybook:"
                      :list="copybookFiles"
                      class="mx-2"
                    >
                    </SummaryGrid>
                    <SummaryGrid
                      labelText="Schema:"
                      :list="schemaFiles"
                      class="mx-2"
                    >
                    </SummaryGrid>
                    <SummaryGrid
                      labelText="Copybook Sequence for Program:"
                      :arr="copybookProgramSeq"
                      class="mx-2"
                    >
                    </SummaryGrid>
                    <SummaryGrid
                      labelText="Copybook Sequence for SQL:"
                      :arr="copybookSQLSeq"
                      class="mx-2"
                    >
                    </SummaryGrid>
                  </fieldset>
                  <fieldset class="mt-5 rounded">
                    <legend class="rounded">
                      Batch Jobs
                    </legend>
                    <EditButton
                      @step="step = 3"
                      class="editbtn"
                    ></EditButton>
                    <SummaryGrid
                      labelText="JCL:"
                      :list="jclFiles"
                      class="mx-2"
                    >
                    </SummaryGrid>
                    <SummaryGrid
                      labelText="JCL Proc:"
                      :list="jclProcFiles"
                      class="mx-2"
                    >
                    </SummaryGrid>
                    <SummaryGrid
                      labelText="JCL Parm Card:"
                      :list="jclParmCardFiles"
                      class="mx-2"
                    >
                    </SummaryGrid>
                  </fieldset>
                  <fieldset class="mt-5 rounded">
                    <legend class="rounded">
                      CICS
                    </legend>
                    <EditButton
                      @step="step = 4"
                      class="editbtn"
                    ></EditButton>
                    <SummaryGrid
                      labelText="CICS:"
                      :list="cicsFiles"
                      class="mx-2"
                    >
                    </SummaryGrid>
                    <SummaryGrid
                      labelText="Mapset(BMS):"
                      :list="bmsFiles"
                      class="mx-2"
                    >
                    </SummaryGrid>
                  </fieldset>
                  <fieldset class="mt-5 rounded">
                    <legend class="rounded">
                      Additional Users
                    </legend>
                    <EditButton
                      @step="step = 5"
                      class="editbtn"
                    ></EditButton>
                    <v-row class="mx-2">
                      <v-col cols="12" sm="2">
                          <div class="text-left">
                              <span> Additional users: </span>
                          </div>                        
                      </v-col>
                      <v-col cols="12" sm="8">
                          <div class="text-left">
                            <v-simple-table v-if="users.length > 0">
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">
                                      First name
                                    </th>
                                    <th class="text-left">
                                      Last name
                                    </th>
                                    <th class="text-left">
                                      Email
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="{firstName, lastName, email} in users"
                                    :key="email"
                                  >
                                    <td>{{ firstName }}</td>
                                    <td>{{ lastName }}</td>
                                    <td>{{ email }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </div>
                      </v-col>
                    </v-row>
                  </fieldset>
                </v-card-text>
              </v-card>
            <v-btn text @click="previous"> 
              <v-icon left> mdi-chevron-double-left </v-icon> Back
            </v-btn>
            <v-btn 
              color="primary"
              @click="handleSubmit"> 
              Submit <v-icon right> mdi-cloud-upload </v-icon>
            </v-btn>

            <ExitWizardButton @click="$emit('exit')" class="floatright">
            </ExitWizardButton>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-form>
    </v-container>
  </v-card>
  <v-alert
    :value="ticketcreatesuccess"
    type="success"
    style="bottom: 25px; left: 0px; right: 0px; position: absolute"
  >
    Submit data successfully.
  </v-alert>

  <v-alert
    :value="ticketcreateerror"
    type="error"
    style="bottom: 25px; left: 0px; right: 0px; position: absolute"
  >
    Submit data unsuccessfully.
  </v-alert>
  <v-footer absolute class="footer">
      <v-spacer></v-spacer>
      <div>&copy; {{ new Date().getFullYear() }} CM First Group</div>
  </v-footer>
  <v-overlay :value="overlay">
    <div class="my-4">Uploading your files...</div>
    <v-progress-linear
      color="blue darken-1"
      indeterminate
      rounded
      height="8"
      ></v-progress-linear>
  </v-overlay>
  </div>
</template>

<script>
import Welcome from '@/components/Welcome.vue'
import CloseableChipFileInput from '../customwidgets/CloseableChipFileInput'
import EditButton from '../customwidgets/EditButton'
import SummaryGrid from '../customwidgets/SummaryGrid'
import ExitWizardButton from '../customwidgets/ExitWizardButton'
import axios from 'axios'

export default {
  name: "Stepper",
  props: ["firstName", "lastName", "email"],
  components: {
    Welcome,
    CloseableChipFileInput,
    EditButton,
    SummaryGrid,
    ExitWizardButton
  },
  data: () => ({
    items: ['English', 'French', 'German', 'Spanish'],
    confirmExitDialog: false,
    dialog: false,
    overlay: false,
    ticketcreatesuccess: false,
    ticketcreateerror: false,
    ApplicationName: '',
    Language: 'English',
    complete: false,
    valid: true,
    Memo: '',
    diffSeqSQL: 'No',
    form1: false,
    selectedProgramSeqItem: 0,
    selectedSQLSeqItem: 0,
    step: 1,
    directoryName: '',
    programFiles: [],
    copybookFiles: [],
    jclFiles: [],
    jclProcFiles: [],
    jclParmCardFiles: [],
    cicsFiles: [],
    bmsFiles: [],
    schemaFiles: [],
    copybookProgramSeq: [],
    copybookSQLSeq: [],
    users: [{
      firstName: "",
      lastName: "",
      email: ""
    }],
    CobolSrcZIPURLs: "",
    CopybookSrcZIPURLs: "",
    JCLSrcZIPURLs: "",
    JCLProcSrcZIPURLs: "",
    JCLParmSrcZIPURLs: "",
    CICSSrcZIPURLs: "",
    MapsetSrcZIPURLs: "",
    SchemaSrcZIPURLs: "",
    requiredRules: [
      (value) => {
        if (value instanceof Array && value.length == 0) {
          return "This field is required.";
        }

        return !!value || "This field is required.";
      },
    ],
  }),
  computed: {

  },
  methods: {
    emailvalidation(firstname, lastname) {
        return [
          (value) => {
            if(firstname != "" && lastname != "" && !value){
              return 'Required.'
            }
            return true;
          },
          (value) => {
            const pattern = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          }
        ]
    },
    setListBoxValues () {
      this.copybookProgramSeq = this.copybookFiles.concat(this.schemaFiles)
      this.copybookSQLSeq = this.copybookFiles.concat(this.schemaFiles)
    },
    next () {
      if(this.$refs.form.validate()){
        this.step++;
      }
    },
    previous () {
      this.step--
    },
    addDirectory () {
      this.copybookProgramSeq.push(this.directoryName);
      this.copybookSQLSeq.push(this.directoryName);
      this.directoryName = '';
      this.$refs.directoryName.focus();
    },
    moveItemUp (arraylst, selectedItemIndex) {
      let selectedIdx = selectedItemIndex
      if (selectedIdx > 0) {
        let topLevelItems = arraylst.slice(0, selectedIdx - 1)
        let aboveSelectedItem = arraylst.slice(selectedIdx - 1, selectedIdx)
        let selectedItem = arraylst.slice(selectedIdx, selectedIdx + 1)
        let bottomLevelItems = arraylst.slice(selectedIdx + 1)
        arraylst = topLevelItems.concat(
          selectedItem,
          aboveSelectedItem,
          bottomLevelItems
        )
      }
      return arraylst
    },
    moveSelectionUp (selectedItemIndex, reference) {
      let selectedIdx = selectedItemIndex
      if (selectedIdx > 0) {
        selectedItemIndex = selectedItemIndex - 1
      }
      reference[selectedItemIndex].$el.scrollIntoView()
      return selectedItemIndex
    },
    moveItemDown (arraylst, selectedItemIndex) {
      let selectedIdx = selectedItemIndex
      if (selectedIdx < arraylst.length) {
        let topLevelItems = arraylst.slice(0, selectedIdx)
        let selectedItem = arraylst.slice(selectedIdx, selectedIdx + 1)
        let belowSelectedItem = arraylst.slice(
          selectedIdx + 1,
          selectedIdx + 2
        )
        let bottomLevelItems = arraylst.slice(selectedIdx + 2)
        arraylst = topLevelItems.concat(
          belowSelectedItem,
          selectedItem,
          bottomLevelItems
        )
      }
      return arraylst
    },
    moveSelectionDown (arraylst, selectedItemIndex, reference) {
      let selectedIdx = selectedItemIndex
      if (selectedIdx < arraylst.length - 1) {
        selectedItemIndex = selectedItemIndex + 1
      }
      reference[selectedItemIndex].$el.scrollIntoView()
      return selectedItemIndex
    },
    addMoreUser() {
      if(this.users.length < 5) {
        this.users.push({})
      }
    },
    uploadFileViaNodeServer: async function (selectedFileArray) {
      const formData = new FormData();

      for (const selectedFile of selectedFileArray) {
        formData.append("file", selectedFile, selectedFile.name);
      }

      var config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      var data = await axios.post(
        process.env.ROOT_API + "/upload",
        formData,
        config
      );

      return data.data;
    },
    buildURL: async function (
      ApplicationName,
      CobolSrcZIPURLs,
      CopybookSrcZIPURLs,
      JCLSrcZIPURLs,
      JCLProcSrcZIPURLs,
      JCLParmSrcZIPURLs,
      CICSSrcZIPURLs,
      MapsetSrcZIPURLs,
      SchemaSrcZIPURLs,
      Memo,
      Language,
      Users
    ) {
      let config = {
        headers: {
          "content-type": "application/json",
        },
      };

      try {
        var uploadedFiles = {};

        if (CobolSrcZIPURLs) {
          uploadedFiles.Cobol = [{ "URL" : CobolSrcZIPURLs, "Memo" : "", "Downloaded" : false, "IsValid" : false }];
        }

        if (CopybookSrcZIPURLs) {
          uploadedFiles.Copybook = [{ "URL" : CopybookSrcZIPURLs, "Memo" : "", "Downloaded" : false, "IsValid" : false }];
        }

        if (JCLSrcZIPURLs) {
          uploadedFiles.JCL = [{ "URL" : JCLSrcZIPURLs, "Memo" : "", "Downloaded" : false, "IsValid" : false }];
        }

        if (JCLProcSrcZIPURLs) {
          uploadedFiles.JCLProc = [{ "URL" : JCLProcSrcZIPURLs, "Memo" : "", "Downloaded" : false, "IsValid" : false }];
        }

        if (JCLParmSrcZIPURLs) {
          uploadedFiles.PARM = [{ "URL" : JCLParmSrcZIPURLs, "Memo" : "", "Downloaded" : false, "IsValid" : false }];
        }

        if (CICSSrcZIPURLs) {
          uploadedFiles.CICS = [{ "URL" : CICSSrcZIPURLs, "Memo" : "", "Downloaded" : false, "IsValid" : false }];
        }

        if (MapsetSrcZIPURLs) {
          uploadedFiles.BMS = [{ "URL" : MapsetSrcZIPURLs, "Memo" : "", "Downloaded" : false, "IsValid" : false }];
        }

        if (SchemaSrcZIPURLs) {
          uploadedFiles.DB2 = [{ "URL" : SchemaSrcZIPURLs, "Memo" : "", "Downloaded" : false, "IsValid" : false }];
        }

        let inputData = {
          TargetModel: "Mainframe",
          CompanyName: "",
          RequestorFirstName: this.firstName,
          RequestorLastName: this.lastName,
          RequestorEmail: this.email,
          ApplicationName: ApplicationName,
          UploadedFiles: uploadedFiles,
          CopybookSeqForProgram: this.copybookProgramSeq,
          CopybookSeqForSQL: this.copybookSQLSeq,
          Language: Language,
          Memo: Memo,
          AdditionalUsers: Users,
        };
        await axios.post(
          process.env.ROOT_API + "/createTicket",
          inputData,
          config
        );

        return true;
      } catch (exc) {
        return false;
      }
    },
    handleSubmit: async function (e) {
      var current = this;
      e.preventDefault();
      current.overlay = true;
      this.$refs.form.validate();
      if(this.programFiles.length > 0) {
        this.CobolSrcZIPURLs = await this.uploadFileViaNodeServer(this.programFiles);
      }
      if(this.copybookFiles.length > 0) {
        this.CopybookSrcZIPURLs = await this.uploadFileViaNodeServer(this.copybookFiles);
      }
      if(this.jclFiles.length > 0) {
        this.JCLSrcZIPURLs = await this.uploadFileViaNodeServer(this.jclFiles);
      }
      if(this.jclProcFiles.length > 0) {
        this.JCLProcSrcZIPURLs = await this.uploadFileViaNodeServer(this.jclProcFiles);
      }
      if(this.jclParmCardFiles.length > 0) {
        this.JCLParmSrcZIPURLs = await this.uploadFileViaNodeServer(this.jclParmCardFiles)
      }
      if(this.cicsFiles.length > 0) {
        this.CICSSrcZIPURLs = await this.uploadFileViaNodeServer(this.cicsFiles);
      }
      if(this.bmsFiles.length > 0) {
        this.MapsetSrcZIPURLs = await this.uploadFileViaNodeServer(this.bmsFiles);
      }
      if(this.schemaFiles.length > 0) {
        this.SchemaSrcZIPURLs = await this.uploadFileViaNodeServer(this.schemaFiles);
      }

      let success = await current.buildURL(
        current.ApplicationName,
        current.CobolSrcZIPURLs,
        current.CopybookSrcZIPURLs,
        current.JCLSrcZIPURLs,
        current.JCLProcSrcZIPURLs,
        current.JCLParmSrcZIPURLs,
        current.CICSSrcZIPURLs,
        current.MapsetSrcZIPURLs,
        current.SchemaSrcZIPURLs,
        current.Memo,
        current.Language,
        current.users
      );

      current.overlay = false;

      if (success) {
        current.ticketcreatesuccess = true;
        current.step = 1;
        current.$refs.form.reset();
        current.Language = 'English';
        current.copybookProgramSeq = [];
        current.copybookSQLSeq = [];
        console.log("Upload is successful");
        setTimeout(function () {
          current.ticketcreatesuccess = false;
        }, 3000);
      } else {
        current.ticketcreateerror = true;
        setTimeout(function () {
          current.ticketcreateerror = false;
        }, 3000);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mainframe/Stepper.vue